'use strict';

const index = require('../node_modules/simple-swizzle/node_modules/is-arrayish/index.js');



module.exports = index.__moduleExports;
